import React, { useRef } from 'react';
import HikiukeResultCard from './HikiukeResultCard.js';
import GuardWarningBanner from './GuardWarningBanner';
import useScrollHandlers from './UseScrollHandler';

const HikiukeCompanyResultSection = ({ company, isMobile, selectedResults, setSelectedResults }) => {
  const scrollRef = useRef(null);
  const scrollHandlers = useScrollHandlers(company.company);

  // Handle scroll with left/right buttons
  const handleScroll = (direction) => {
    const scrollContainer = scrollRef.current;
    if (scrollContainer) {
      // Calculate scroll amount based on card width
      const cardWidth = 350 + 15; // card width + margin
      const scrollAmount = cardWidth * 1; // scroll 1 cards at once

      const newScrollLeft = direction === 'left'
        ? scrollContainer.scrollLeft - scrollAmount
        : scrollContainer.scrollLeft + scrollAmount;

      scrollContainer.scrollTo({
        left: newScrollLeft,
        behavior: 'smooth'
      });
    }
  };

  // pdfUrlから"YYYYMM版"を抽出
  function extractEdition(pdfUrl) {
    if (!pdfUrl) return '';
    const match = pdfUrl.match(/(\d{6}版)/);
    return match ? match[1] : '';
  }

  // 表示用会社名を返す(pdfUrlに版情報があれば付与)
  function getDisplayCompanyName() {
    if (company.results && company.results[0]?.pdfUrl) {
      const edition = extractEdition(company.results[0].pdfUrl);
      if (edition) {
        return `${company.company}（${edition}）`;
      }
    }
    return company.company;
  }

  const isGuarded = company.results?.[0]?.underGuardControl === true;

  return (
    <div className="company-section">
      <div className="company-header align-top">
        <div className="company-name-row">
          <h3 className="company-name">{getDisplayCompanyName()}</h3>
          {isGuarded && <GuardWarningBanner />}
        </div>
      </div>
      <div className="scroll-nav-wrapper">
        <div
          className={`results-grid ${isMobile ? 'mobile' : ''}`}
          ref={scrollRef}
          onTouchStart={(e) => scrollHandlers.handleTouchStart(e, scrollRef.current)}
          onTouchMove={(e) => scrollHandlers.handleTouchMove(e, scrollRef.current)}
          onTouchEnd={() => scrollHandlers.handleTouchEnd(scrollRef.current)}
          onMouseDown={(e) => scrollHandlers.handleMouseDown(e, scrollRef.current)}
          onMouseMove={(e) => scrollHandlers.handleMouseMove(e, scrollRef.current)}
          onMouseUp={() => scrollHandlers.handleMouseUp(scrollRef.current)}
          onMouseLeave={() => scrollHandlers.handleMouseLeave(scrollRef.current)}
        >
          <div className="scroll-indicator"></div>
          <div className="swipe-hint">← スワイプしてスクロール →</div>

          {company.results.map((result) => (
            <HikiukeResultCard
              key={result.id}
              result={result}
              isDragging={scrollHandlers.isDragging}
              companyId={company.company}
              selectedResults={selectedResults}
              setSelectedResults={setSelectedResults}
            />
          ))}
        </div>
        <div className="scroll-nav">
          <button
            className="scroll-button scroll-button-left"
            onClick={() => handleScroll('left')}
            aria-label="左にスクロール"
          >
            ◀
          </button>
          <button
            className="scroll-button scroll-button-right"
            onClick={() => handleScroll('right')}
            aria-label="右にスクロール"
          >
            ▶
          </button>
        </div>
      </div>
    </div>
  );
};

export default HikiukeCompanyResultSection;
